module.exports = __webpack_public_path__ + "img/cake.529b5af2.svg";